(()=>{
  const q=(s,c=document)=>c.querySelector(s), qa=(s,c=document)=>[...c.querySelectorAll(s)];
  const setHidden=(el,v)=>{ if(el) el.hidden=v; };
  const root=(window.GOTU_THEME&&window.GOTU_THEME.root)||'/';

  const intro=q('[data-site-intro]');
  if(intro){
    document.body.classList.add('intro-open');
    let closed=false;
    const closeIntro=()=>{
      if(closed) return;
      closed=true;
      intro.classList.add('is-leaving');
      document.body.classList.remove('intro-open');
      setTimeout(()=>intro.remove(),850);
    };
    q('[data-intro-enter]',intro)?.addEventListener('click',closeIntro);
    const duration=Math.max(2000,Number(window.GOTU_THEME?.introDuration)||4000);
    setTimeout(closeIntro,duration);
  }

  const header=q('[data-header]');
  addEventListener('scroll',()=>header&&header.classList.toggle('scrolled',scrollY>20),{passive:true});

  const menu=q('[data-mobile-menu]');
  qa('[data-menu-open]').forEach(b=>b.addEventListener('click',()=>setHidden(menu,false)));
  qa('[data-menu-close]').forEach(b=>b.addEventListener('click',()=>setHidden(menu,true)));

  const drawer=q('[data-cart-drawer]');
  qa('[data-cart-open]').forEach(b=>b.addEventListener('click',()=>setHidden(drawer,false)));
  qa('[data-cart-close]').forEach(b=>b.addEventListener('click',()=>setHidden(drawer,true)));

  const search=q('[data-search-overlay]');
  qa('[data-search-open]').forEach(b=>b.addEventListener('click',()=>{ setHidden(search,false); setTimeout(()=>q('input',search)?.focus(),50); }));
  qa('[data-search-close]').forEach(b=>b.addEventListener('click',()=>setHidden(search,true)));
  document.addEventListener('keydown',e=>{ if(e.key==='Escape'){ setHidden(menu,true); setHidden(drawer,true); setHidden(search,true); } });


  const initCampaignSlideshows=(scope=document)=>{
    qa('[data-gotu-slideshow]',scope).forEach(slider=>{
      if(slider.dataset.gotuInitialized==='true') return;
      const slides=qa('[data-gotu-slide]',slider);
      const dots=qa('[data-gotu-dot]',slider);
      const current=q('[data-gotu-current]',slider);
      const prev=q('[data-gotu-prev]',slider);
      const next=q('[data-gotu-next]',slider);
      if(!slides.length) return;
      slider.dataset.gotuInitialized='true';
      let index=0, timer=null;
      const interval=Math.max(3000,Number(slider.dataset.interval)||5000);
      const show=(target)=>{
        index=(target+slides.length)%slides.length;
        slides.forEach((slide,i)=>{
          const active=i===index;
          slide.classList.toggle('is-active',active);
          slide.setAttribute('aria-hidden',active?'false':'true');
        });
        dots.forEach((dot,i)=>{
          const active=i===index;
          dot.classList.toggle('is-active',active);
          active?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current');
        });
        if(current) current.textContent=String(index+1).padStart(2,'0');
      };
      const stop=()=>{ if(timer){ clearInterval(timer); timer=null; } };
      const start=()=>{ stop(); if(slides.length>1) timer=setInterval(()=>show(index+1),interval); };
      prev?.addEventListener('click',()=>{ show(index-1); start(); });
      next?.addEventListener('click',()=>{ show(index+1); start(); });
      dots.forEach((dot,i)=>dot.addEventListener('click',()=>{ show(i); start(); }));
      slider.addEventListener('mouseenter',stop);
      slider.addEventListener('mouseleave',start);
      slider.addEventListener('focusin',stop);
      slider.addEventListener('focusout',start);
      show(0);
      start();
      slider._gotuShow=show;
      slider._gotuStart=start;
      slider._gotuStop=stop;
    });
  };
  initCampaignSlideshows();
  document.addEventListener('shopify:section:load',e=>initCampaignSlideshows(e.target));
  document.addEventListener('shopify:block:select',e=>{
    const block=e.target.closest?.('[data-gotu-slide]');
    const slider=block?.closest?.('[data-gotu-slideshow]');
    if(!block||!slider||!slider._gotuShow) return;
    const slides=qa('[data-gotu-slide]',slider);
    const i=slides.indexOf(block);
    if(i>=0){ slider._gotuStop?.(); slider._gotuShow(i); }
  });
  document.addEventListener('shopify:block:deselect',e=>{
    const slider=e.target.closest?.('[data-gotu-slideshow]');
    slider?._gotuStart?.();
  });


  const form=q('[data-product-form]');
  if(form){
    const variant=q('[data-variant-select]',form), btn=q('[data-add-button]',form);
    const syncVariant=()=>{
      if(!variant||!btn) return;
      const opt=variant.options[variant.selectedIndex];
      const available=opt?.dataset.available==='true';
      btn.disabled=!available;
      btn.textContent=available?'Add to bag':'Sold out';
      const productPrice=q('[data-product-price]');
      if(productPrice&&opt?.dataset.price) productPrice.textContent=opt.dataset.price;
    };
    variant?.addEventListener('change',syncVariant);
    syncVariant();
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      btn.disabled=true; btn.textContent='Adding…';
      try{
        const res=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
        if(!res.ok){ const err=await res.json().catch(()=>({})); throw new Error(err.description||'Unable to add item'); }
        const cart=await fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
        qa('[data-cart-count]').forEach(x=>x.textContent=cart.item_count);
        const body=q('[data-cart-drawer-body]');
        if(body) body.innerHTML=`<p>${cart.item_count} item${cart.item_count===1?'':'s'} in your bag.</p><a class="add-button" href="${root}cart">View bag</a>`;
        setHidden(drawer,false);
        btn.textContent='Added';
        setTimeout(syncVariant,1200);
      }catch(err){
        btn.textContent=err.message||'Try again';
        setTimeout(syncVariant,1800);
      }
    });
  }

  const cartForm=q('[data-cart-form]');
  if(cartForm){
    const updateButton=q('[data-cart-update]',cartForm);
    const submitUpdate=()=>{
      if(updateButton&&cartForm.requestSubmit) cartForm.requestSubmit(updateButton);
      else cartForm.submit();
    };

    qa('[data-quantity-input]',cartForm).forEach(input=>{
      let previousValue=Math.max(0,parseInt(input.value,10)||0);
      const setQuantity=value=>{
        const quantity=Math.max(0,parseInt(value,10)||0);
        input.value=quantity;
        if(quantity!==previousValue){
          previousValue=quantity;
          submitUpdate();
        }
      };

      const control=input.closest('.cart-quantity__control');
      q('[data-quantity-minus]',control)?.addEventListener('click',()=>setQuantity(Number(input.value)-1));
      q('[data-quantity-plus]',control)?.addEventListener('click',()=>setQuantity(Number(input.value)+1));
      input.addEventListener('change',()=>setQuantity(input.value));
    });
  }
})();
